import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {AuthService} from '../authentication.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {Constants} from '../../../shared/utils/constants';
import {AppService} from '../../../app.service';

@Component({
  selector: 'fx-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass'],
})
export class LoginComponent implements OnInit, OnDestroy {
  user: any = {};
  params: any;
  errorMessage = 'Username or password is not valid.';
  showError = false;
  subscription: Subscription;
  hide = true;
  @ViewChild('form', { static: false }) form: NgForm;
  constructor(
    private service: AuthService,
    private router: Router,
    private appService: AppService,
    activatedRoute: ActivatedRoute,
  ) {
    const token = localStorage.getItem('access_token');
    activatedRoute.queryParams.subscribe((params) => {
      this.params = params;
    });
    if (token) {
      if (this.params.returnUrl) {
        router.navigate([this.params.returnUrl]);
      } else {
        router.navigate(['/app/dashboard']);
      }
    }
  }

  ngOnInit(): void {}

  login(): void {
    this.showError = false;
    if (this.form.valid) {
      this.subscription = this.service
        .login(this.user)
        .subscribe((data) => {
          if (data.status === Constants.RESPONSE_STATUS.SUCCESS) {
            data.data.username = this.user.username;
            localStorage.setItem(
              'USER_LOGGED',
              JSON.stringify(data.data),
            );
            if (this.params.returnUrl) {
              this.router.navigate([this.params.returnUrl]);
            } else {
              const permission = JSON.parse(
                localStorage.getItem('permission') || '{}'
              );
              const routerRedirect = Object.keys(Constants.PERMISSION_CONSTANT);
              const keyPermission = Object.values(Constants.PERMISSION_CONSTANT);
              let statusPermission = false;
              keyPermission.some((v, i) => {
                if (permission[v] === 1 || permission[v] === 2) {
                  this.router.navigate([routerRedirect[i]]);
                  statusPermission = true;
                  return true;
                }
              });
              if (!statusPermission) {
                this.appService.showError('Permission invalid!');
              }
            }
          } else {
            this.showError = true;
            this.errorMessage =
              data.message || 'Username or password is not valid.';
          }
        });
    } else {
      this.showError = true;
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
